/** Частота повторення: день / тиждень / місяць / рік. */
export const RECURRENT_FREQUENCIES = ['day', 'week', 'month', 'year'];
/** ISO-дні тижня: понеділок = 1 … неділя = 7. */
export const RECURRENT_WEEKDAYS = [1, 2, 3, 4, 5, 6, 7];
/** Спосіб завершення серії. */
export const RECURRENT_END_TYPES = ['never', 'date', 'count'];
export const RECURRENT_INTERVAL_MIN = 1;
export const RECURRENT_INTERVAL_MAX = 365;
export const RECURRENT_MONTH_DAY_MIN = 1;
export const RECURRENT_MONTH_DAY_MAX = 31;
export const RECURRENT_COUNT_MIN = 1;
export const RECURRENT_COUNT_MAX = 999;
/** Скільки копій створюється за один прохід (створення або тік воркера). */
export const RECURRENT_BATCH_LIMIT = 10;
/** Горизонт серії «ніколи», днів уперед. */
export const RECURRENT_HORIZON_DAYS = 90;
/** Коментар зупинки серії або видалення вільних задач. */
export const RECURRENT_COMMENT_MAX = 500;
